import Selectr from 'mobius1-selectr';
import './selectr.css';
import './multi-select.less';

(function () {
	const multiSelects = [].slice.call(document.querySelectorAll(
		'.js-multi-select'
	));

	multiSelects.forEach(select => {
		// eslint-disable-next-line
		let selector = new Selectr(select, {
			multiple: true,
			placeholder: 'Please select a region'
		});
		selector.on('selectr.change', () => {
			const removeButton = [].slice.call(document.querySelectorAll('.selectr-tag-remove'));

			if (removeButton.length > 0) {
				for (let i = 0; i < removeButton.length; i++) {
					removeButton[i].innerHTML = 'Remove';
				}
			}
		});

		const ua = window.navigator.userAgent;
		const msie = ua.indexOf('MSIE ');

		// eslint-disable-next-line
		if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {  // If Internet Explorer, please delete it...
			const selectorDOM = [].slice.call(document.querySelectorAll('.selectr-selected'));
			const inputs = [].slice.call(document.querySelectorAll('.selectr-input'));

			if (selectorDOM.length > 0) {
				for (let i = 0; i < selectorDOM.length; i++) {
					selectorDOM[i].addEventListener('keydown', e => {
						if (e.keyCode === 40) {
							e.preventDefault();
							selector.open();
						}
					});
				}
				for (let i = 0; i < inputs.length; i++) {
					inputs[i].addEventListener('keydown', e => {
						if (e.keyCode === 27) {
							e.preventDefault();
							selector.close();
						}
					});
				}
			}
		}
	});
	const input = [].slice.call(document.querySelectorAll('.selectr-input'));
	const labelForInput = document.createElement('label');
	const id = 'selectrInput';
	const clearButton = [].slice.call(document.querySelectorAll('.selectr-input-clear'));

	labelForInput.setAttribute('for', id);
	labelForInput.setAttribute('class', 'accessibility-hidden');
	labelForInput.innerHTML = 'Select';
	if (input.length > 0) {
		input[0].setAttribute('id', id);
		input[0].parentElement.appendChild(labelForInput);
		if (clearButton.length > 0) {
			clearButton[0].innerHTML = 'Clear';
		}
	}
}());
